import React, { Component, lazy, Suspense } from 'react';
import postal from 'postal';
import { object } from 'prop-types';
import { Menu } from '@material-ui/icons';
import { generateNavigationProps } from 'utils/HeaderHelper';
import { wrapEventHandler } from 'utils/handlers';
import * as styles from './styles/styles.module.scss';

const SideDrawer = lazy(() => import('../SideDrawer'));

class NavigationDrawer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      // props passed in for state for logging in and out without a page refresh
      ...generateNavigationProps({
        communityFeatureFlag: props.featureFlags.communityFeatureFlag,
        currentUser: props.currentUser,
        languageRegionCode: props.languageRegionCode,
        proUser: props.proUser
      }),
      isMounted: false
    };
  }

  componentDidMount() {
    if (this.props.messagingChannel) {
      this.props.messagingChannel.subscribe('navigation.loginUser', this.updateForLoggedInUser);
    }
    this.setState({ isMounted: true });
  }

  componentWillUnmount() {
    // This check for "unsubscribe" prevents weird HMR issues
    if (this.props.messagingChannel && typeof this.props.messagingChannel.unsubscribe === 'function') {
      this.props.messagingChannel.unsubscribe('navigation.loginUser');
    }
  }

  updateForLoggedInUser = data => {
    const loggedInState = generateNavigationProps({
      communityFeatureFlag: this.props.featureFlags.communityFeatureFlag,
      currentUser: data.currentUser,
      languageRegionCode: this.props.languageRegionCode,
      proUser: data.proUser
    });
    this.setState({ ...loggedInState });
  };

  toggleIsOpen = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen }, this.toggleWindowLockAndTrack);
  };

  toggleWindowLockAndTrack() {
    _gaq.push(['_trackEvent', 'Mobile Header', 'Toggle', window.location.pathname]);
    this.toggleWindowLock();
  }

  toggleWindowLock() {
    if (this.state.isOpen) {
      document.querySelector('html').classList.add('mobile-screen-lock');
    } else {
      document.querySelector('html').classList.remove('mobile-screen-lock');
    }
  }

  renderSideDrawer() {
    if (!this.state.isMounted) {
      return null;
    }

    return (
      <Suspense fallback={null}>
        <SideDrawer
          currentUser={this.props.currentUser}
          featureFlags={this.props.featureFlags}
          isOpen={this.state.isOpen}
          links={this.state.links}
          toggleIsOpen={wrapEventHandler(this.toggleIsOpen)}
          user={this.state.user}
        />
      </Suspense>
    );
  }

  render() {
    return (
      <div>
        <a href="#" onClick={wrapEventHandler(this.toggleIsOpen)} className={styles.navigationMenuLink} data-testid="navigationDrawer-menuButton">
          <Menu className={styles.navigationMenu} />
        </a>
        {this.renderSideDrawer()}
      </div>
    );
  }
}

NavigationDrawer.propTypes = {
  currentUser: object,
  messagingChannel: object
};

NavigationDrawer.defaultProps = {
  currentUser: null,
  messagingChannel: postal.channel('navigation_messagingChannel')
};

export default NavigationDrawer;
